module.exports = "/wwwroot/img/WFS.png?ver=4859a462";